import type { ProductsState } from '../types';
import { getPageNumbers } from './pageNumbers';

export const getProductCountUpToEndOfPage = (
  productsByPage: ProductsState['pages'],
  currentPage: number,
) => {
  return getPageNumbers(productsByPage).reduce((acc, pageNumber) => {
    if (pageNumber <= currentPage) {
      return acc + productsByPage[pageNumber].length;
    }
    return acc;
  }, 0);
};
